import { render, staticRenderFns } from "./MoreButton.vue?vue&type=template&id=3d71879e&scoped=true&"
import script from "./MoreButton.vue?vue&type=script&lang=js&"
export * from "./MoreButton.vue?vue&type=script&lang=js&"
import style0 from "./MoreButton.vue?vue&type=style&index=0&id=3d71879e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d71879e",
  null
  
)

export default component.exports